import React, { useEffect, useState, MouseEvent } from 'react';
import { Title } from '../../../../component/title/Title';
import Table from '../../../../component/table/Table.component';
import { HEAD_CELL } from './utils/HEAD_CELL';
import ButtonBackComponent from '../../../../component/buttton/ButtonBack.component';
import MenuItem from '@material-ui/core/MenuItem';
import { FormInput, FormSelect } from '../../../../component/input/InputStyle';
import FormLabel from '../../../../component/input/FormLabel.component';
import ButtonFinish from '../../components/buttonFinish/ButtonFinish.component';
import { useManagement } from '../../../../context/Management';
import {getDoca, postParticularity, getParticularity, putParticularity} from './Scheduling.service';
import { ACTION_EDIT, Action } from '../../../../component/table/interfaces/TableInterface';
import useModal from '../../../../hooks/useModal';
import ModalUpdate from './components/modal/ModalUpdate.component';
import GridComponent from '../../../../component/grid/GridComponent.component';
import { INITIAL_PAGINATION } from '../../../../component/table/component/pagination/utils/Pagination';
import { Pagination } from '../../../../component/table/interfaces/Pagination';
import { compare } from '../../../../utils/order/compare';
import FormFilter from './components/form/FormFilter.component'
import { InterfaceTable, InterfaceTableModal } from './interface/InterfaceSchedulingDock';
import Loader from '../../../../component/Loader/LoaderComponent';
import { useSnackbar } from '../../../../context/Snackbar';

const ParticularityDock = () => {
    const {valueCd} = useManagement();
    const { setSnackbar } = useSnackbar();
    const [valueDockAPI, setValueDockAPI] = useState<InterfaceTable[]>([]);
    const [valueDock, setValueDock] = useState("");
    const [valueStore, setValueStore] = useState('');
    const [startTimeValue, setStartTimeValue] = useState("");
    const [endTimeValue, setEndTimeValue] = useState("");
    const [checked, setChecked] = useState([
        {
            name: 'Todos os dias',
            isChecked: false
        },
        {
            name: 'Segunda',
            isChecked: false
        },
        {
            name: 'Terça',
            isChecked: false
        },
        {
            name: 'Quarta',
            isChecked: false
        },
        {
            name: 'Quinta',
            isChecked: false
        },
        {
            name: 'Sexta',
            isChecked: false
        },
        {
            name: 'Sábado',
            isChecked: false
        },
        {
            name: 'Domingo',
            isChecked: false
        },
    ]);
    const [select, setSelect] = useState(false);
    const [table, setTable] = useState<InterfaceTable[]>([]);
    const [open, addModal] = useModal();
    const [tableValue, setTableValue] = useState<any>([]);
    const [pagination, setPagination] = useState<Pagination>(INITIAL_PAGINATION);
    const [buttonFilter, setButtonFilter] = useState(false);
    const [tableAux, setTableAux] = useState<InterfaceTable[]>([]);
    const [loading, setLoading] = useState(Boolean)

    const handleChangeDay = (e: any) => {
        const { name } = e.target
        const copy = [...checked];
        if (name === 'Todos os dias') {
            checked.map((change: any, index: number) => {
                copy[index].isChecked = !select
                setChecked(copy)
                /* console.log(index) */
            })
            setSelect(!select)
            /* console.log(checked) */
        }  else {
            const indexCheckbox = checked.findIndex((object: any) => {
                return object.name === name
            })
            if (checked[0].isChecked) {
                copy[indexCheckbox].isChecked = !copy[indexCheckbox].isChecked;
                copy[0].isChecked = false;
                setSelect(false);
                setChecked(copy);
            } else {
                copy[indexCheckbox].isChecked = !copy[indexCheckbox].isChecked;
                setChecked(copy);
            }
        }
    };

    const handleChange = (e: any) => {
        const {value, name} = e.target
        if (name === 'Docas') {
            setValueDock(value);
        } else if (name === 'Lojas') {
            setValueStore(value);
            //  console.log(valueStore)
        } else if (name === 'horarioInicio') {
            setStartTimeValue(value);
        } else {
            setEndTimeValue(value);
        }
    }

    const getDay = (item: InterfaceTable) => {
        /* console.log('domingo', item.domingo) */
        let days = '';
        if (item.domingo === 1) days+=('Domingo,')
        if (item.segunda === 1) days+=(' Segunda,')
        if (item.terca === 1) days+=(' Terça,')
        if (item.quarta === 1) days+=(' Quarta,')
        if (item.quinta === 1) days+=(' Quinta,')
        if (item.sexta === 1) days+=(' Sexta,')
        if (item.sabado === 1) days+=(' Sábado,')
       /*  console.log('days', days) */
        return days.slice(0, -1)
    }

    const getParticularityDock = async () => {
        try {
            setLoading(true);
            const res = await getParticularity(`${valueCd}`);
            /* console.log('a', res.data); */
            const tableScheduling = res.data.map((item: InterfaceTable) => {
                const data = {
                    id: item.id,
                    Docas: item.doca,
                    Lojas: item.loja,
                    DiaSemana: getDay(item),
                    HorarioInicio: item.horarioInicio,
                    HorarioFim: item.horarioFim,
                    Status: item.status === 'I' ? 'Indisponível' : 'Disponível'
                }
                return data
            })
            setTable(tableScheduling)
            setTableAux(tableScheduling)
            setLoading(false);
        } catch(error) {
            setLoading(false);
            setSnackbar({msg: 'Erro na comunicação com a API.', subMsg: 'Não foi possível mostrar a tabela.', type: 'error'})
            console.log(error);
        }
    }

    const getDock = async () => {
        try {
            const res = await getDoca(`${valueCd}`);
            // console.log('doca', res.data);
            setValueDockAPI(res.data);
            /* console.log('opa', valueDockAPI) */
        } catch(error) {
            setSnackbar({msg: 'Erro na comunicação com a API.', subMsg: 'Não foi possível mostrar as docas do CD selecionado.', type: 'error'})
            console.log(error);
        }
    }

    useEffect(() => {
        getDock();
        getParticularityDock();
    }, [valueCd]);


    const handleSubmitParticularity = async (e: any) => {
        /* console.log('dock',checked) */
        const data = {
            id: 0,
            cd: valueCd,
            doca: valueDock,
            loja: valueStore,
            domingo: checked[7].isChecked,
            segunda: checked[1].isChecked,
            terca: checked[2].isChecked,
            quarta: checked[3].isChecked,
            quinta: checked[4].isChecked,
            sexta: checked[5].isChecked,
            sabado: checked[6].isChecked,
            horarioInicio: startTimeValue,
            horarioFim: endTimeValue,
            status: 'Disponível'
        }
        if (!data.domingo && !data.segunda && !data.terca && !data.quarta && !data.quinta && !data.sexta && !data.sabado) {
            window.alert('Não foi possível cadastrar. Você nao preencheu todos os campos.');
        } else {
            try {
                const res = await postParticularity(data);
                // console.log(res);
                if (res) {
                    window.alert('Cadastrado com sucesso.');
                    getParticularityDock();
                    cleanInputs();
                }
            } catch(error) {
                setSnackbar({msg: 'Erro na comunicação com a API', subMsg: 'Não foi possível mostrar as docas do CD selecionado', type: 'error'})
                console.log(error);
            }
        }
    };

    const cleanInputs = () => {
        setValueDock('');
        setValueStore('');
        setChecked([
            {
                name: 'Todos os dias',
                isChecked: false
            },
            {
                name: 'Segunda',
                isChecked: false
            },
            {
                name: 'Terça',
                isChecked: false
            },
            {
                name: 'Quarta',
                isChecked: false
            },
            {
                name: 'Quinta',
                isChecked: false
            },
            {
                name: 'Sexta',
                isChecked: false
            },
            {
                name: 'Sábado',
                isChecked: false
            },
            {
                name: 'Domingo',
                isChecked: false
            },
        ]);
        setStartTimeValue('');
        setEndTimeValue('');
    }

    const closeModal = async (newDock: string, newStore: string, newDay: any, newStartDate: string, newEndDate: string, id: number, newStatus: string) => {
        const data = {
            id: id,
            cd: valueCd,
            doca: newDock,
            loja: newStore,
            domingo: newDay[7].isChecked,
            segunda: newDay[1].isChecked,
            terca: newDay[2].isChecked,
            quarta: newDay[3].isChecked,
            quinta: newDay[4].isChecked,
            sexta: newDay[5].isChecked,
            sabado: newDay[6].isChecked,
            horarioInicio: newStartDate,
            horarioFim: newEndDate,
            status: newStatus
        }
        // console.log(data)
        try {
            const res = await putParticularity(data);
            // console.log('put', res)
            if (res) {
                setSnackbar({msg: 'Dados atualizados com sucesso', type: 'success'})
                addModal(!open);
                getParticularityDock();
            }
        } catch(error) {
            setSnackbar({msg: 'Erro na comunicação com a API.', subMsg: 'Não foi possível atualizar os dados.', type: 'error'})
            console.log(error);
            addModal(!open);
        }

    }

    const handleClickAction = async (action: Action, value: InterfaceTableModal, index: number) => {
        if (action === ACTION_EDIT) {

            addModal(!open);
            setTableValue(value);
        }
    }

    const pageSelect = (tableAux: InterfaceTable[]) => {
        if (pagination.page) {
            return tableAux.slice((pagination.page - 1) * 30, pagination.page * 30)
        }
        return tableAux;
    }

    const handleChangePage = (_event: unknown, newPage: number) => {
        setPagination({ ...pagination, page: newPage + 1 });
    };

    const handleRequestSort = (_event: MouseEvent<unknown>, property: string) => {
        const isAsc = pagination.sort === property && pagination.order === 1;
        setTableAux(tableAux.sort((a: any, b: any) => compare(a, b, property, isAsc ? -1 : 1)))
        setPagination({ ...pagination, sort: property, order: isAsc ? -1 : 1 });
    };

    const handleSubmitSearch = (dock: any) => {
        let tableSchedulingDockAux: any[] = [...table].filter((el: any) => {
            let includesDock: boolean = !dock.Docas || String(el.Docas).toLocaleLowerCase().includes(String(dock.Docas).toLocaleLowerCase());
            let includesStore: boolean = !dock.Lojas || String(el.Lojas).toLocaleLowerCase().includes(String(dock.Lojas).toLocaleLowerCase());
            /* console.log('dock', includesDock) */
            return includesDock && includesStore;
        });
        const empty: boolean = !dock.Docas && !dock.Lojas;
        /* console.log('aquii', tableSchedulingDockAux) */
        setTableAux(empty ? [...table] : tableSchedulingDockAux);
    };

    /* const handleFocus = () => {
        if (valueStore.length === 0) {
            setValueStore('B')
        } else {
            setValueStore(valueStore)
        }
    }

    const handleBlur = () => {
        if (valueStore === 'B') {
            setValueStore('');
        }
    } */

    return (
        <>
            <ButtonBackComponent to="/gestao-de-patio" />
            <Title fontSize={30} fontWeigth='900' margin="0px 0px 20px 0px">Agendamento das Docas</Title>
            <GridComponent justify="space-between" spacing={2} margin="0px 0px 20px 0px">
                <FormLabel title='Doca' sm={3} md={2} lg={1}>
                    <FormSelect
                        name="Docas"
                        value={valueDock}
                        onChange={handleChange}
                    >
                        <MenuItem disabled>Selecionar Doca</MenuItem>
                        {valueDockAPI.map((item:InterfaceTable,index:number)=>(
                            <MenuItem key={index} value={item.id}> {item.id}
                            </MenuItem>
                        ))}
                    </FormSelect>
                </FormLabel>
                <FormLabel title='Loja'  sm={3} md={2} lg={1}>
                    <FormInput
                        title="Digite somente o numero da Loja !"
                        name="Lojas"
                        value={valueStore}
                        onChange={handleChange}
                        /* onFocus={handleFocus}
                        onBlur={handleBlur} */
                    />
                </FormLabel>
                <FormLabel title='Dias da semana' sm={4} md={4}>
                    <ul style={{margin: '0 auto', padding: '0px'}}>
                        {checked.map((day: any, index: number) => (
                            <div style={{display: 'inline', marginLeft: '13px', textAlign: 'center'}}>
                                <label key={index} htmlFor={day.name}>{day.name}
                                <input type="checkbox" name={day.name} id={day.name} value={day.name} checked={checked[index].isChecked} onChange={handleChangeDay}/>
                                </label>
                            </div>
                        ))}
                    </ul>
                </FormLabel>
                <FormLabel title='Horário Início'  sm={3} md={2} lg={2}>
                <FormInput
                        type='time'
                        name='horarioInicio'
                        value={startTimeValue}
                        onChange={handleChange}
                    />
                </FormLabel>
                <FormLabel title="Horário Fim"  sm={3} md={2} lg={2}>
                    <FormInput
                        type='time'
                        name='horarioFim'
                        value={endTimeValue}
                        onChange={handleChange}
                    />
                </FormLabel>
                    <ButtonFinish name="Gravar" title='Gravar' type='submit' onClick={handleSubmitParticularity} margin>Gravar</ButtonFinish>
            </GridComponent>
            <GridComponent justify='flex-end' margin='50px 0px 0px 0px'>
                <ButtonFinish name="filtrar" onClick={()=> setButtonFilter(!buttonFilter)}>Filtrar</ButtonFinish>
            </GridComponent>
            {open && <ModalUpdate open={!!open} handleClick={() => addModal(!open)} title={'Atualizar Dados'} onClickSubmit={closeModal} dock={valueDockAPI} data={tableValue}/>}
            <GridComponent justify="flex-start" margin='0px 0px 20px 0px'>
                {buttonFilter && <FormFilter handleSubmitForm={handleSubmitSearch}/>}
            </GridComponent>
            {loading ? <Loader /> : <Table
                headCells={HEAD_CELL}
                data={pageSelect(tableAux)}
                page={pagination.page}
                size={tableAux.length}
                onChangePage={handleChangePage}
                order={pagination.order === 1 ? 'asc' : 'desc'}
                orderBy={pagination.sort}
                onRequestSort={handleRequestSort}
                noActionDelete
                noActionView
                handleClickAction={handleClickAction} />}
        </>
    )
}
export default ParticularityDock;
